export default __webpack_public_path__ + "static/media/location-icon.3f1a22aa.svg";